import '~/scripts/integrations/jquery-extended';

export function writeToast(text, type, relative = false, target = '') {
  type = type || 'success';
  var positionStyle = "z-index: 11000;";

  // Place toast near `target` element if `relative` is true
  if (relative) {
    positionStyle += "position: relative; bottom: 10px; right: 2px;";
  } else {
    positionStyle += "position: fixed; top: 85px; left: 10px;";
  }

  const html = `<div class="flash-wrapper" style="${positionStyle}">
    <div class="toast align-items-center show text-white bg-${type} border-0" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="d-flex">
        <div class="toast-body">${text}</div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
      </div></div></div></div>`;

  // Remove active flash messages because ajax flash are appended on existing div present on DOM; relevant for relatively positioned toast
  if (relative) { $(target).find('.flash-wrapper').remove(); }

  relative ? $(target).append(html) : $body.append(html);

  setTimeout(function() {
    $('.flash-wrapper').fadeOut(2000, function() {
      $('.flash-wrapper').remove();
    });
  }, 4000);
}

export function bindCopyText(textElSelector, buttonSelector) {
  const $copyButton = $(buttonSelector);
  const $textToCopy = $(textElSelector);

  $copyButton.on(R.touchEvent, function() {
    const toastMessage = this.dataset.copyMessage || 'Copied';
    navigator.clipboard.writeText($textToCopy.text())
      .then(function() {
        writeToast(toastMessage);
      })
      .catch(function(error) {
        console.error('Failed to copy text: ', error);
      });
  });
}
